import React from "react";
import { Link } from "react-router-dom";
import "../styles/Homepage.css";

// Helper function to determine tag color class (copied from DishPage.jsx)
const getTagClassName = (tag) => {
  if (typeof tag !== 'string') return '';
  const lowerTag = tag.toLowerCase().trim();
  
  // Spice Level
  if (lowerTag === 'hot') return 'tag-hot';
  if (lowerTag === 'medium') return 'tag-medium';
  if (lowerTag === 'mild') return 'tag-mild';
  if (lowerTag === 'no spice') return 'tag-no-spice';
  
  // Dietary (Vegetarian/Vegan)
  if (lowerTag === 'vegetarian' || lowerTag === 'vegan') return 'tag-veggie';
  
  // Dietary Restrictions / Allergens (-Free)
  if (lowerTag === 'gluten free') return 'tag-gluten-free';
  if (lowerTag === 'soy free') return 'tag-soy-free';
  if (lowerTag === 'dairy free') return 'tag-dairy-free';
  if (lowerTag === 'nut free') return 'tag-nut-free';
  if (lowerTag === 'shellfish free') return 'tag-shellfish-free';
  if (lowerTag === 'egg free') return 'tag-egg-free';
  if (lowerTag === 'fish free') return 'tag-fish-free';
  if (lowerTag === 'sesame free') return 'tag-sesame-free';
  
  // Contains Specific Allergen
  if (lowerTag === 'contains seafood') return 'tag-contains-seafood';
  
  // Cuisine Types
  if (lowerTag === 'mexican') return 'tag-mexican';
  if (lowerTag === 'chinese') return 'tag-chinese';
  if (lowerTag === 'japanese') return 'tag-japanese';
  if (lowerTag === 'korean') return 'tag-korean';
  if (lowerTag === 'indian') return 'tag-indian';
  if (lowerTag === 'american') return 'tag-american';
  if (lowerTag === 'italian') return 'tag-italian';
  
  return '';
};

const DishSuggestion = ({ dishes }) => {
  // If no dishes provided or empty array, return null
  if (!dishes || dishes.length === 0) return null;

  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const imagePrefix = isLocalhost ? "" : "https://webdev.cse.buffalo.edu/hci/teams/indecisive";

  return (
    <div className="dish-suggestion-container">
      <div className="dish-suggestion-header">
        <h3>Suggested Dishes Based on Your Filters</h3>
        <p>We found these dishes that match your dietary preferences:</p>
      </div>
      
      <div className="dish-suggestions">
        {dishes.slice(0, 3).map((dish) => (
          <Link 
            key={dish.id} 
            to={`/dish/${dish.id}`}
            className="dish-suggestion-link"
          >
            <div className="dish-card">
              <div className="dish-image">
                <img 
                  src={dish.image ? `${imagePrefix}${dish.image}` : "https://via.placeholder.com/150?text=No+Image"} 
                  alt={dish.title} 
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/150?text=No+Image";
                  }}
                />
              </div>
              <div className="dish-info">
                <h4>{dish.title}</h4>
                <p className="dish-restaurant">{dish.restaurantName}</p>
                <p className="dish-description">{dish.description}</p>
                <div className="dish-tags">
                  {dish.tags && dish.tags.map((tag, index) => {
                    const specificTagClass = getTagClassName(tag);
                    const finalClassName = `dish-tag ${specificTagClass}`.trim();
                    return (
                      <span key={index} className={finalClassName}>
                        {tag}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default DishSuggestion; 